var _g, _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 386,
    viewBox: "0 0 360 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_14009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 76H339.5V289.333H19.5V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.963 147.173C218.521 129.412 171.49 106.49 134.334 134.986C117.053 148.24 122.417 157.751 112.467 176.528C106.537 187.72 96.0312 198.391 96.7334 211.24C97.3368 222.331 103.14 232.362 110.991 237.392C128.647 248.703 156.621 250.623 171.246 217.235C185.87 183.847 237.991 192.979 223.963 147.173V147.173Z",
    fill: "url(#paint0_linear_57_14009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.912 190.555C253.374 182.82 241.87 184.562 224.441 191.086C211.334 195.995 199.333 200.291 187.842 211.234C179.798 218.89 174.202 227.831 170.567 236.033C166.627 244.919 160.63 255.462 166.885 262.664C175.479 272.556 210.114 273.547 237.053 249.532C266.645 223.146 268.284 198.113 260.912 190.555Z",
    fill: "url(#paint1_linear_57_14009)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.656 175.878C136.456 175.878 123.322 162.743 123.322 146.544C123.322 130.345 136.456 117.211 152.656 117.211C168.855 117.211 181.989 130.345 181.989 146.544C181.989 162.743 168.855 175.878 152.656 175.878ZM152.656 253.389C136.456 253.389 123.322 240.334 123.322 224.233C123.322 208.132 136.456 195.078 152.656 195.078C168.855 195.078 181.989 208.132 181.989 224.233C181.989 240.334 168.855 253.389 152.656 253.389ZM235.5 175.878C219.301 175.878 206.167 162.743 206.167 146.544C206.167 130.345 219.301 117.211 235.5 117.211C251.699 117.211 264.833 130.345 264.833 146.544C264.833 162.743 251.699 175.878 235.5 175.878Z",
    fill: "#6200EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.278 142.1L233.058 154.545L225.722 147.079",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.056 142.1L150.836 154.545L143.5 147.079",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.056 219L150.836 231.444L143.5 223.979",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.008 186.751L191.008 186.752L209.273 245.13C210.832 250.1 217.815 250.237 219.568 245.316L227.886 221.909L228.261 220.854L229.357 220.622L251.78 215.877C256.869 214.797 257.664 207.856 252.948 205.652L191.008 186.751ZM191.008 186.751C189.598 182.253 194.199 178.224 198.477 180.218C198.477 180.218 198.477 180.218 198.477 180.218C198.477 180.218 198.478 180.218 198.478 180.218L252.948 205.652L191.008 186.751Z",
    stroke: "#FD6B35",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9939 237.522C86.3025 243.943 98.0995 242.589 98.0995 242.589C98.0995 242.589 99.6607 230.824 93.3461 224.408C87.0374 217.987 75.2461 219.336 75.2461 219.336C75.2461 219.336 73.6853 231.101 79.9939 237.522V237.522Z",
    fill: "url(#paint2_linear_57_14009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12 110.231C230.141 113.641 221.743 110.188 221.743 110.188C221.743 110.188 223.045 101.208 229.027 97.8014C235.006 94.3909 243.4 97.8394 243.4 97.8394C243.4 97.8394 242.099 106.82 236.12 110.231V110.231Z",
    fill: "url(#paint3_linear_57_14009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.885 123.567C122.74 129.822 111.248 128.503 111.248 128.503C111.248 128.503 109.728 117.043 115.879 110.793C122.024 104.538 133.51 105.853 133.51 105.853C133.51 105.853 135.03 117.313 128.885 123.567V123.567Z",
    fill: "url(#paint4_linear_57_14009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6333 181.922C88.5788 181.922 90.9667 184.39 90.9667 187.433C90.9667 190.477 88.5788 192.944 85.6333 192.944C82.6878 192.944 80.3 190.477 80.3 187.433C80.3 184.39 82.6878 181.922 85.6333 181.922Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.322 236.889C249.322 233.379 246.477 230.534 242.967 230.534C239.457 230.534 236.611 233.379 236.611 236.889C236.611 240.399 239.457 243.245 242.967 243.245C246.477 243.245 249.322 240.399 249.322 236.889Z",
    stroke: "#FD6B35",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.678 161.689C110.034 161.689 111.944 159.779 111.944 157.422C111.944 155.066 110.034 153.156 107.678 153.156C105.321 153.156 103.411 155.066 103.411 157.422C103.411 159.779 105.321 161.689 107.678 161.689Z",
    fill: "#6200EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.256 191.166C129.176 191.166 128.3 190.291 128.3 189.211C128.3 188.131 129.176 187.255 130.256 187.255C131.336 187.255 132.211 188.131 132.211 189.211C132.211 190.291 131.336 191.166 130.256 191.166Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1 209.689C280.536 209.689 283.322 206.983 283.322 203.645C283.322 200.306 280.536 197.6 277.1 197.6C273.664 197.6 270.878 200.306 270.878 203.645C270.878 206.983 273.664 209.689 277.1 209.689Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.833 257.689C195.092 257.689 196.922 255.858 196.922 253.6C196.922 251.342 195.092 249.511 192.833 249.511C190.575 249.511 188.744 251.342 188.744 253.6C188.744 255.858 190.575 257.689 192.833 257.689Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.9 115.078C162.98 115.078 163.856 114.123 163.856 112.944C163.856 111.766 162.98 110.811 161.9 110.811C160.82 110.811 159.944 111.766 159.944 112.944C159.944 114.123 160.82 115.078 161.9 115.078Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.811 177.833C253.811 178.913 254.766 179.789 255.944 179.789C257.123 179.789 258.078 178.913 258.078 177.833C258.078 176.753 257.123 175.878 255.944 175.878C254.766 175.878 253.811 176.753 253.811 177.833Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.878 151.344C271.86 151.344 272.656 150.628 272.656 149.744C272.656 148.861 271.86 148.144 270.878 148.144C269.896 148.144 269.1 148.861 269.1 149.744C269.1 150.628 269.896 151.344 270.878 151.344Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7 169.478C95.78 169.478 96.6556 168.761 96.6556 167.878C96.6556 166.994 95.78 166.278 94.7 166.278C93.62 166.278 92.7444 166.994 92.7444 167.878C92.7444 168.761 93.62 169.478 94.7 169.478Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.788 116.408C203.21 118.563 204.489 120.777 206.643 121.354C208.798 121.932 211.012 120.653 211.589 118.499C212.166 116.344 210.888 114.13 208.734 113.553C206.579 112.975 204.365 114.254 203.788 116.408Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.839 135.378H101.785C101.463 139.605 98.0778 139.67 98.0778 139.67C98.0778 139.67 101.811 139.738 101.811 144.622C101.811 139.738 105.544 139.67 105.544 139.67C105.544 139.67 102.16 139.605 101.839 135.378ZM269.145 120.445H269.057C268.537 128.086 263.056 128.204 263.056 128.204C263.056 128.204 269.1 128.326 269.1 137.156C269.1 128.326 275.144 128.204 275.144 128.204C275.144 128.204 269.665 128.086 269.145 120.445Z",
    fill: "#E1E4E5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 357,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#6200EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 183,
    y: 357,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6200EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 194,
    y: 357,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6200EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_14009",
    x1: 144.99,
    y1: 57.7165,
    x2: 186.68,
    y2: 368.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_14009",
    x1: 210.754,
    y1: 140.777,
    x2: 220.029,
    y2: 357.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_14009",
    x1: 105.164,
    y1: 259.455,
    x2: 59.5562,
    y2: 187.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_57_14009",
    x1: 213.033,
    y1: 121.126,
    x2: 261.478,
    y2: 78.0211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_57_14009",
    x1: 104.366,
    y1: 144.932,
    x2: 148.793,
    y2: 75.2885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_14009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 213.333,
    fill: "white",
    transform: "translate(19.5 76)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome1);
export default __webpack_public_path__ + "static/media/welcome1.1e5899be.svg";
export { ForwardRef as ReactComponent };